import React from 'react';
import { Container, Row, Col, Card, ProgressBar } from 'react-bootstrap';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Backend Development',
      skills: [
        { name: 'Java & Spring Boot', level: 95 },
        { name: 'Microservices Architecture', level: 90 },
        { name: 'REST APIs & GraphQL', level: 92 },
        { name: 'Hibernate & JPA', level: 90 },
      ],
    },
    {
      title: 'Database & Storage',
      skills: [
        { name: 'MySQL & PostgreSQL', level: 90 },
        { name: 'MongoDB & NoSQL', level: 88 },
        { name: 'Redis & Caching', level: 85 },
        { name: 'Database Design', level: 92 },
      ],
    },
    {
      title: 'System Design & Architecture',
      skills: [
        { name: 'System Design', level: 90 },
        { name: 'Cloud Architecture (AWS)', level: 85 },
        { name: 'Docker & Kubernetes', level: 88 },
        { name: 'CI/CD Pipelines', level: 85 },
      ],
    },
    {
      title: 'Additional Expertise',
      skills: [
        { name: 'Python', level: 85 },
        { name: 'React & Frontend', level: 80 },
        { name: 'Git & Version Control', level: 95 },
        { name: 'Agile Methodologies', level: 90 },
      ],
    },
  ];

  return (
    <section id="skills" className="py-5 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h2 className="section-title text-center">Technical Expertise</h2>
            <p className="section-subtitle text-center">
              Mastery across the full stack with deep specialization in backend engineering
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          {skillCategories.map((category, idx) => (
            <Col lg={6} key={idx} className="mb-4">
              <Card className="h-100">
                <Card.Body>
                  <h4 className="fw-bold mb-4">{category.title}</h4>
                  {category.skills.map((skill, skillIdx) => (
                    <div key={skillIdx} className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <span className="fw-semibold">{skill.name}</span>
                        <span className="text-muted">{skill.level}%</span>
                      </div>
                      <ProgressBar now={skill.level} variant="primary" />
                    </div>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="mt-5">
          <Col lg={12}>
            <div className="text-center">
              <h4 className="fw-bold mb-4">Technologies I Work With</h4>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                {[
                  'Java', 'Spring Boot', 'Spring Cloud', 'Hibernate', 'MySQL', 'PostgreSQL',
                  'MongoDB', 'Redis', 'Kafka', 'Docker', 'Kubernetes', 'AWS', 'Git',
                  'Jenkins', 'Maven', 'Gradle', 'JUnit', 'Mockito', 'React', 'Python',
                ].map((tech, idx) => (
                  <span
                    key={idx}
                    className="badge bg-white text-dark border px-3 py-2 fs-6"
                    style={{ fontWeight: 500 }}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Skills;